import { useLang } from "@/lib/i18n";

export const WhatsAppIcon = ({ className = "h-6 w-6" }) => (
  <svg viewBox="0 0 32 32" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.004 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.26.59 4.46 1.71 6.4L3.2 28.8l6.58-1.67a12.74 12.74 0 0 0 6.22 1.62h.01c7.06 0 12.79-5.74 12.79-12.8 0-3.42-1.33-6.63-3.75-9.05a12.72 12.72 0 0 0-9.05-3.7zm0 23.39h-.01a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-4.02 1.02 1.07-3.92-.25-.4a10.58 10.58 0 0 1-1.63-5.66c0-5.87 4.78-10.64 10.65-10.64 2.84 0 5.51 1.11 7.52 3.12a10.57 10.57 0 0 1 3.11 7.53c0 5.87-4.78 10.66-10.65 10.66zm5.84-7.97c-.32-.16-1.9-.94-2.19-1.04-.29-.11-.51-.16-.72.16-.21.32-.82 1.04-1.01 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.22-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55l-.61-.01c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66 0 1.57 1.14 3.08 1.3 3.29.16.21 2.25 3.44 5.45 4.82.76.33 1.36.53 1.82.67.77.24 1.46.21 2.01.13.61-.09 1.9-.78 2.16-1.53.27-.75.27-1.39.19-1.53-.08-.13-.29-.21-.61-.37z" />
  </svg>
);

export const WhatsAppButton = ({ phone = "15145787858" }) => {
  const { lang } = useLang();
  const t = lang === "fr"
    ? { prefill: "Bonjour Rang1! J'ai une question sur le SEO / vos outils.", label: "Des questions? Clavardez sur WhatsApp", aria: "Clavarder avec nous sur WhatsApp" }
    : { prefill: "Hi Rang1! I have a question about SEO / your tools.", label: "Questions? Chat on WhatsApp", aria: "Chat with us on WhatsApp" };
  const text = encodeURIComponent(t.prefill);
  return (
    <a
      href={`https://wa.me/${phone}?text=${text}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.aria}
      data-testid="whatsapp-float-button"
      className="fixed bottom-5 right-5 z-50 group flex items-center gap-0 rounded-full bg-[#25D366] text-white shadow-lg hover:shadow-xl transition-shadow"
    >
      <span className="flex h-14 w-14 items-center justify-center">
        <WhatsAppIcon className="h-7 w-7" />
      </span>
      <span className="max-w-0 overflow-hidden whitespace-nowrap text-sm font-medium transition-[max-width,padding] duration-200 group-hover:max-w-[220px] group-hover:pr-5">
        {t.label}
      </span>
    </a>
  );
};

export default WhatsAppButton;
